import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // for navigation
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css'; // Import the Quill editor's styles
import ReactQuill from "react-quill";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

function DailyWorkPlanList() {
    const [planDetails, setPlanDetails] = useState([{ date: '', day: '', plan: '' }]);
    const [selectedWeek, setSelectedWeek] = useState({ start: '', end: '' });
    const [weekDays, setWeekDays] = useState([]);
    const [selectedDay, setSelectedDay] = useState("");  // To store the selected day
    const [filteredData, setFilteredData] = useState([]);  // Store filtered data from API
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();  // For navigation

    const { selectedPIDData } = location.state || {};

    const handleWeekChange = (e) => {
        const value = e.target.value;

        // Ensure that the value is not empty or invalid
        if (!value) {
            setWeekDays([]); // Clear weekDays if no valid week is selected
            setSelectedDay(null); // Reset selected day when no week is selected
            setSelectedWeek(null);
            return; // Exit if no week is selected
        }

        try {
            const weekRange = JSON.parse(value); // Parse the week data safely
            setSelectedWeek(weekRange); // Update selected week state

            const startDate = new Date(weekRange.start);

            const dayOfWeek = startDate.getDay();

            // If the start date is Sunday (0), adjust to Monday (1)
            if (dayOfWeek === 0) {
                startDate.setDate(startDate.getDate() + 1); // Move to the next day (Monday)
            }
            const days = [];

            // Generate weekdays based on the selected start of the week
            for (let i = 0; i < 5; i++) {
                const day = new Date(startDate);
                day.setDate(startDate.getDate() + i);
                days.push({
                    value: day.toISOString().split('T')[0], // Format as 'YYYY-MM-DD'
                    label: day.toLocaleString('default', { weekday: 'long' }) // Weekday name
                });
            }

            // Update weekDays state with the generated weekdays
            setWeekDays(days);
            // Reset selected day and ensure it's not disabled
            setSelectedDay(null); // Ensure that the day dropdown is reset when selecting a new week
        } catch (error) {
            console.error("Invalid JSON input", error);
        }
    };


    const [previousDay, setPreviousDay] = useState(null); // State to track the previously selected day

    const handleDayChange = (e) => {
        const selectedValue = e.target.value; // Get the selected value from the event

        if (selectedValue === "") {
            setSelectedDay(null);
            setFilteredData([]); // Optionally clear any filtered data
            return;
        }
      
        if (loading || !selectedValue) return; // Prevent making the request again if already loading or invalid selection
        
        if (selectedValue) {
            setLoading(true);
            const selectedDay = weekDays.find(day => day.value === selectedValue);
            setSelectedDay(selectedDay);
            setFilteredData([]);

            fetchDailyWorkPlanData(selectedValue);
            setPreviousDay(selectedValue);
        }
    };



    const getWeekOptions = () => {
        const options = [];
        const currentDate = new Date();

        // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const currentDay = currentDate.getDay();
        const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay;  // Calculate days to the previous Monday
        currentDate.setDate(currentDate.getDate() + daysUntilMonday); // Set to the start of the current week (Monday)

        // Get the start of the current week (Monday)
        const startOfWeek = new Date(currentDate);
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 4); // End of the week is 5 days after Monday (Friday)

        // Create the label for the current week (e.g., "Dec 4 - Dec 8")
        const weekLabel = `${startOfWeek.toLocaleString('default', { month: 'short' })} ${startOfWeek.getDate()} - ${endOfWeek.toLocaleString('default', { month: 'short' })} ${endOfWeek.getDate()}`;

        // Create the value for the current week (in ISO format)
        const weekRange = { start: startOfWeek.toISOString().split('T')[0], end: endOfWeek.toISOString().split('T')[0] };

        // Add the current week as the only option
        options.push(<option key={0} value={JSON.stringify(weekRange)}>{weekLabel}</option>);

        return options;
    };


    const handleViewDetails = (workPlanId, startDate) => {
        navigate(`/edit_daily_work_plan`, { 
            state: { workPlanId, startDate, selectedWeek, selectedDay }
        });
    };
    

    // Fetch data based on the selected date
    const fetchDailyWorkPlanData = async (date) => {
        const headers = await getApiHeader();
        try {
            // Only proceed if not already loading
            setLoading(true);

            const data = { date: date };
            const response = await axios.post(`${SERVER_URL}work-plan/get-daily-work-list`, data, {
                headers: headers
            });

            if (response.status === 200) {
                // Update filteredData with the daily work list
                setFilteredData(response.data.data.daily_work_list);
            } else {
                console.error('Failed to fetch data', response.message);
            }
        } catch (error) {
            console.error('Error fetching data', error);
        } finally {
            // Set loading to false after the request is done (whether success or error)
            setLoading(false);
        }
    };


    useEffect(() => {
        if (location.state) {
            const { startDate, selectedWeek, selectedDay } = location.state;
            if (startDate && selectedWeek) {
                setSelectedWeek(selectedWeek);
                handleWeekChange({ target: { value: JSON.stringify(selectedWeek) } });
                setSelectedDay(selectedDay);
                fetchDailyWorkPlanData(selectedDay.value); 
            }
        }

    }, [location.state], [selectedWeek, selectedDay]);
    

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <div className="container">
                <form className="workplanform col-lg-12">
                <h4>Approve/Reject Daily Work</h4>
                    <div className="row">
                    {location.state && location.state.reviewer ? (
                        <div className="work-details">
                            <h4>{location.state.reviewer.name} Work Details</h4> <br />
                        </div>
                    ) : (
                        <div className="form-group col-lg-6">
                            <label htmlFor="work-week" className="label">Select a Week:</label>
                            <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} value={selectedWeek ? JSON.stringify(selectedWeek) : ""}>
                                <option value="">Please choose an option</option>
                                {getWeekOptions()}
                            </select>
                        </div>
                    )}


                        <div className="form-group col-lg-6">
                            <label htmlFor="work-day" className="label">Select a Day:</label>
                            <select
                                id="work-day"
                                name="work-day"
                                className="select"
                                onChange={handleDayChange}
                                value={selectedDay ? selectedDay.value : ""} // Set selected day value
                                disabled={!selectedWeek} // Disable the day selection if no week is selected
                            >
                                <option value="">Please choose a day</option>
                                {weekDays.map((day) => (
                                    <option key={day.value} value={day.value}>
                                        {day.label}
                                    </option>
                                ))}
                            </select>
                        </div>


                    </div>

                    {/* Show loader while fetching data */}
                    {loading ? (
                        <div className="text-center">
                            <Loader /> {/* Loader component */}
                        </div>
                    ) : selectedDay ? (

                        <div className="table-responsive mt-3">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Sl No</th>
                                        {/* <th>PID</th> */}
                                        <th>Name</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((data, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                {/* <td>{data.retailer_id}</td> */}
                                                <td>{data.retailer_name}</td>

                                                <td>
                                                    {data.status === 1 ? 'Approved' :
                                                        data.status === 2 ? 'Rejected' :
                                                            'Pending'}
                                                </td>
                                                <td>{data.date}</td>
                                                <td>
                                                    {data.status == 0 && (
                                                        <button
                                                            className="btn btn-danger btn-sm ms-2"
                                                            style={{ backgroundColor: '#e20e75' }}
                                                            onClick={() => handleViewDetails(data.daily_work_id, data.date)}
                                                        >
                                                            View Work Details
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">No Daily Work Plan available for the selected day.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div></div>
                    )}

                </form>
            </div>

        </DashboardLayout>
    );
}

export default DailyWorkPlanList;
